import type { VoidFunctionComponent } from 'react';

import Button from '../../../../generic/Button';
import useRebuildRevision from '../hooks/useRebuildRevision';

import styles from '../FileViewer.module.less';

type Props = {
  revisionLocator: string;
};

/**
 * FileViewerFileContentsNotFound displays a message to the user
 * in cases where the file blob could not be fetched.
 *
 * It displays a button where users can reanalyze the package,
 * however users will need to reload the drawer/page in order
 * to view it (as it's an async task which rebuilds the dep).
 */
const FileViewerFileContentsNotFound: VoidFunctionComponent<Props> = ({ revisionLocator }) => {
  const { hasRebuilt, onRebuild } = useRebuildRevision(revisionLocator);
  return (
    <div className={styles.fileContentsNotFound}>
      File is unavailable for preview
      <Button
        size="medium"
        type="secondary"
        isDisabled={hasRebuilt}
        onClick={onRebuild}
      >
        {hasRebuilt ? 'Reanalyzing Dependency' : 'Reanalyze Dependency'}
      </Button>
    </div>
  );
};

export default FileViewerFileContentsNotFound;
